import { useEffect, useRef } from '@wordpress/element';

const SkypeButton = ({ attributes, clientId }) => {
	const { skypeID, type, isWhite, size } = attributes;

	const sbbSkypeButton = useRef(null);

	useEffect(() => {
		sbbSkypeButton.current.innerHTML = '';

		sbbSkypeButton.current && Skype.ui({
			name: type,
			element: `sbbSkypeButtonEl-${clientId}`,
			participants: [skypeID],
			imageSize: size,
			imageColor: isWhite ? 'white' : ''
		});
	}, [sbbSkypeButton.current, skypeID, type, isWhite, size]);

	return <div className='sbbSkypeButton' id={`sbbSkypeButtonEl-${clientId}`} ref={sbbSkypeButton}></div>
}
export default SkypeButton;